<template>
  <v-select
    v-model="item"
    :dir="$dir"
    :clearable="false"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x.Id === val"
    :disabled="disabled"
    @open="onOpen"
    :multiple="multiple"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  components: {
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.sicknessSelect }),
    ...mapState('zirehState', { flag: state => state.sicknessSelectFlag }),
    item: {
      get() {
        if (this.val) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setSicknessSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.sickness.getall, {},
        )
          .then(res => {
            this.$store.commit('zirehState/setSicknessSelect', res.data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
